/**
 * Picture links in the website chat.
 *
 * A customer picture arrives as a signed link (`/object/sign/…?token=…`), valid for an hour. Only an old
 * public link (`/object/public/…`) can go through Supabase's thumbnail renderer; anything else, a signed
 * link above all, must stay exactly as the server sent it or its token breaks.
 */

/** Shown as `data-picture-link` on an <img> that draws a signed link: lets us tell the served build has this code. */
export const SIGNED_LINK_MARKER = 'chuck-signed-picture-link-v1';

const PUBLIC_OBJECT_PATH = '/storage/v1/object/public/';

/** Thumbnail link for a public Supabase picture; every other link is returned untouched. */
export function getThumbnailUrl(url: string): string {
  if (!url || !url.includes('supabase') || !url.includes(PUBLIC_OBJECT_PATH)) return url;

  // Convert /storage/v1/object/public/… to /storage/v1/render/image/public/… at 400px wide.
  return `${url.replace(PUBLIC_OBJECT_PATH, '/storage/v1/render/image/public/')}?width=400&resize=contain`;
}

/** A link that carries a signing token. */
export function isSignedLink(url: string): boolean {
  return /[?&]token=/.test(url);
}
